<template>
    <div class="msg">
        <div v-show="visbile && type==='success'" class="success">{{msg}}</div>
        <div v-show="visbile && type==='fail'" class="fail">{{msg}}</div>
        <div v-show="visbile && type==='warning'" class="warning">{{msg}}</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                msg:"",
                type:"",
                visbile:false
            }
        }
    }
</script>

<style scoped>
    .msg div{
        position:fixed;
        z-index: 99999;
        left:50%;
        top:20px;
        margin-left: -240px;
        width:480px;
        height: 48px;
        font-size: 20px;
        text-align: center;
        line-height: 48px;
        border-radius: 4px;
        animation:showMsg 0.5s linear;
    }
    @media (max-width:767px){
        .msg div{
            width:60%;
            margin-left: -30%;
            font-size: 16px;
        }
    }
    .success{
        background: #f0f9eb;
        color: #67c23a;
        border:1px solid #c2e7b0;
    }
    .fail{
        background: #fef0f0;
        color: #F56C6C;
        border:1px solid #fbc4c4;
    }
    .warning{
        background: #fdf6ec;
        color: #E6A23C;
        border:1px solid #f5dab1;
    }
    @keyframes showMsg{
        0%{
            opacity: 0;
        }
        100%{
            opacity: 1;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Msg/Msg.vue